<template>
  <div class="inline-flex gap-3 justify-between">
    <div class="flex items-center h-16 w-16 border shrink-0">
      <NuxtImg :src="logo" class="max-h-full max-w-full" quality="90" loading="lazy" @error="setDefaultImage" :alt="data.name" :title="data.name" />
    </div>
    <div class="flex flex-col gap-0.5">
      <h5 class="text-md font-semibold line-clamp-1">{{ data.name }}</h5>
      <p class="text-xs text-gray-700 dark:text-gray-400" :class="lineClampClass">{{ formattedAddress }}</p>
    </div>
  </div>
</template>

<script setup>
const props = defineProps(['data', 'lines']);
const address = props.data?.locations.address || {};
const { street = '', locality = '', city = '', state = '', area_code = '' } = address;
const formattedAddress = [
  locality, 
  street && street !== locality ? street : null, 
  city, 
  state, 
  area_code
].filter(Boolean) 
 .join(', ');
const logo = useSecureImage(props.data.images.thumbnail || props.data.images.gallery[0] || undefined);
const lineClampClass = props.lines ? `line-clamp-${props.lines}` : 'line-clamp-2';

const runtimeConfig = useRuntimeConfig();
const setDefaultImage = (event) => {
  event.imageSrc = runtimeConfig.public.defaultProductImage;
}


</script>
